export default "__VITE_PUBLIC_ASSET__86e7dd4b__"